import React from "react";
import "./css/CompanyInformation.css";

export const CompanyInformation: React.FC = () => {
    return (
        <div className="company-container">
            <p className="company-text">
                FAR Authoring Ltd. is the organisation behind Skitterbook. The company
                is based in the United Kingdom and will be formally registered as a UK
                limited company when required for operational and commercial purposes.
            </p>

            <p className="company-text">
                Our aim is to support creative tools and digital experiences that are
                simple, reliable, and enjoyable to use. Skitterbook is part of this
                ongoing commitment to accessible, user‑centred design.
            </p>
        </div>
    );
};

export default CompanyInformation;
